import { fromJS, Map } from 'immutable';
import * as actionTypes from '../actions/mainUIActionTypes';
import * as sessionActionTypes from '../actions/sessionActionTypes';
import * as metaActionTypes from '../actions/metaAttachActionTypes';
import { viewTypes } from '../constants/umoGallery';
import * as mainContentTypes from '../constants/mainContentTypes';
import appConfig from '../appConfig';

// Load saved nav panel width from localStorage or use default
const getInitialNavPanelWidth = () => {
  const savedWidth = localStorage.getItem('navPanelWidth');
  return savedWidth ? parseInt(savedWidth, 10) : 285;
};

const initialState = fromJS({
  isNavPanelShown: false,
  navPanelWidth: getInitialNavPanelWidth(),
  isWorkspacePreviewShown: false,
  isAdvancedSearchShown: false,
  isHighlightsViewShown: false,
  isFullImageViewShown: false,
  fullImageUmoData: undefined,
  emailWorkspaceData: undefined,
  UMOModifyData: undefined,
  umoList: undefined,
  isPortal: undefined,
  shownUMODetailView: undefined,
  mainContentType: mainContentTypes.SEARCH_UMO,
  mainContentData: {},
  umoGalleryViewType:
    appConfig.umoGallery && appConfig.umoGallery.gridViewDefault
      ? viewTypes.GRID_NOJ
      : viewTypes.GRID,
  gallerySortMode: false,
  categoryToMoveID: null,
  fileUploader: {
    showFileUploader: false,
    isMinimized: false,
    isCollapsed: false,
    isUploading: false,
  },
  categoryToMoveName: null,
  modalWorkspaceID: null,
  dialogView: null,
  dialogData: null,
  metaPanelUmoId: null,
  isMetaPanelShown: false,
  navPanelComponent: null,
});

const mainUI = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.MAINUI_BULK_META_EDIT:
      return state.set('mainContentType', mainContentTypes.BULK_META_EDIT);
    case actionTypes.MAINUI_NAV_PANEL_TOGGLE:
      return state.set(
        'isNavPanelShown',
        action.show === undefined ? !state.get('isNavPanelShown') : action.show
      );
    case actionTypes.TRIGGER_NAV_PANEL_COMPONENT:
      return state.set('navPanelComponent', action.payload);
    case actionTypes.MAINUI_WORKSPACE_PREVIEW_TOGGLE:
      return state
        .set(
          'isWorkspacePreviewShown',
          action.show === undefined
            ? !state.get('isWorkspacePreviewShown')
            : action.show
        )
        .set('isAdvancedSearchShown', false);
    case actionTypes.MAINUI_ADVANCED_SEARCH_TOGGLE:
      return state
        .set(
          'isAdvancedSearchShown',
          action.show === undefined
            ? !state.get('isAdvancedSearchShown')
            : action.show
        )
        .set('isWorkspacePreviewShown', false);
    case actionTypes.MAINUI_UMO_DETAIL_VIEW_TOGGLE: {
      // value for shownUMODetailView should be either a umo ID or undefined
      return state.set(
        'shownUMODetailView',
        action.show === undefined || action.show === false
          ? undefined
          : action.show
      );
    }
    case actionTypes.MAINUI_SET_META_PANEL_ID: {
      return state
        .set('metaPanelUmoId', action.id)
        .set('isMetaPanelShown', !!action.id);
    }
    case actionTypes.MAINUI_META_PANEL_TOGGLE: {
      return state.set('isMetaPanelShown', action.show);
    }
    case actionTypes.MAINUI_TOGGLE_FULL_IMAGE_VIEW: {
      // value for shownUMODetailView should be either a umo ID or undefined
      return state
        .set(
          'isFullImageViewShown',
          action.show === undefined || action.show === false
            ? undefined
            : action.show
        )
        .set('fullImageUmoData', action.umoData);
    }
    case actionTypes.MAINUI_UMO_COMPARE_VIEW_TOGGLE: {
      // value for shownWorkspaceDetailView should be either a umo ID or undefined
      return state
        .set(
          'shownWorkspaceDetailView',
          action.show === undefined || action.show === false
            ? undefined
            : action.show
        )
        .set('modalWorkspaceID', action.modalWorkspaceID);
    }
    case actionTypes.MAINUI_WORKSPACE_DETAIL_VIEW_TOGGLE: {
      // value for shownWorkspaceDetailView should be either a umo ID or undefined
      return state
        .set(
          'shownWorkspaceDetailView',
          action.show === undefined || action.show === false
            ? undefined
            : action.show
        )
        .set('modalWorkspaceID', action.modalWorkspaceID);
    }
    case actionTypes.MAINUI_UMO_GRID_VIEW: {
      return state.set('umoGalleryViewType', viewTypes.GRID);
    }
    case actionTypes.MAINUI_UMO_GRID_NOJ_VIEW: {
      return state.set('umoGalleryViewType', viewTypes.GRID_NOJ);
    }
    case actionTypes.MAINUI_UMO_LIST_VIEW: {
      return state.set('umoGalleryViewType', viewTypes.LIST);
    }
    case actionTypes.MAINUI_UMO_SM_GRID_NOJ_VIEW: {
      return state.set('umoGalleryViewType', viewTypes.SM_GRID_NOJ);
    }
    case actionTypes.MAINUI_UMO_CAROUSEL_VIEW: {
      return state.set('umoGalleryViewType', viewTypes.CAROUSEL);
    }
    case actionTypes.MAINUI_MANUAL_SORT_TOGGLE: {
      return state.set(
        'gallerySortMode',
        action.show === undefined ? !state.get('gallerySortMode') : action.show
      );
    }
    case actionTypes.MAINUI_SHOW_MAIN_SEARCH: {
      return state
        .set('mainContentType', mainContentTypes.SEARCH_UMO)
        .set('isHighlightsViewShown', false)
        .set('shownUMODetailView', undefined)
        .set('gallerySortMode', false)
        .set('mainContentData', new Map());
    }
    case actionTypes.MAINUI_SHOW_HIGHLIGHTS: {
      return state
        .set('mainContentType', mainContentTypes.SEARCH_UMO)
        .set('shownUMODetailView', undefined)
        .set('isHighlightsViewShown', true)
        .set('mainContentData', new Map());
    }
    case actionTypes.MAINUI_SHOW_ADMIN_SCREEN: {
      return state
        .set('mainContentType', mainContentTypes.ADMIN_SCREEN)
        .set('isHighlightsViewShown', false)
        .set('shownUMODetailView', undefined)
        .set('mainContentData', new Map({ screenType: action.adminType }));
    }
    case actionTypes.MAINUI_SHOW_RECORD_SCREEN: {
      return state
        .set('mainContentType', mainContentTypes.RECORD_SCREEN)
        .set('isHighlightsViewShown', false)
        .set('shownUMODetailView', undefined)
        .set('mainContentData', new Map({ screenType: action.recordType }));
    }
    case actionTypes.MAINUI_SHOW_MAIN_EXTERNAL_LOADING: {
      return state
        .set('mainContentType', mainContentTypes.EXTERNAL_URL)
        .set('shownUMODetailView', undefined)
        .set(
          'mainContentData',
          new Map({ isLoading: true, urlFunction: action.urlFunction })
        );
    }
    case actionTypes.MAINUI_SHOW_MAIN_EXTERNAL_SUCCESS: {
      // following conditional makes sure that if urlFunction exists, that it matches.
      // urlFunction is optional and given when an async call is required to create the url to
      // be used to populate the main content area. this check makes sure that this "success"
      // action is for appropriate "load" action.
      if (
        !action.urlFunction ||
        (action.urlFunction &&
          state.getIn(['mainContentData', 'urlFunction']) ===
            action.urlFunction)
      ) {
        return state
          .set('mainContentType', mainContentTypes.EXTERNAL_URL)
          .set('shownUMODetailView', undefined)
          .set('mainContentData', new Map({ url: action.url }));
      }
      return state;
    }
    case actionTypes.MAINUI_SHOW_MAIN_ADMIN_LOADING: {
      return state
        .set('mainContentType', mainContentTypes.EXTERNAL_ADMIN_SCREEN)
        .set('shownUMODetailView', undefined)
        .set(
          'mainContentData',
          new Map({ isLoading: true, urlFunction: action.urlFunction })
        );
    }
    case actionTypes.MAINUI_SHOW_MAIN_ADMIN_SUCCESS: {
      // following conditional makes sure that if urlFunction exists, that it matches.
      // urlFunction is optional and given when an async call is required to create the url to
      // be used to populate the main content area. this check makes sure that this "success"
      // action is for appropriate "load" action.
      if (
        !action.urlFunction ||
        (action.urlFunction &&
          state.getIn(['mainContentData', 'urlFunction']) ===
            action.urlFunction)
      ) {
        return state
          .set('mainContentType', mainContentTypes.EXTERNAL_ADMIN_SCREEN)
          .set('shownUMODetailView', undefined)
          .set('mainContentData', new Map({ url: action.url }));
      }

      return state;
    }
    case actionTypes.MAINUI_SHOW_MAIN_DIALOG:
      return state
        .set('dialogView', action.dialogType)
        .set('dialogData', action.dialogData);
    case actionTypes.MAINUI_HIDE_MAIN_DIALOG:
      return state.set('dialogView', undefined).set('dialogData', undefined);
    case actionTypes.MAINUI_SHOW_WORKSPACE_EMAIL_DIALOG:
      return state
        .set('emailWorkspaceData', fromJS(action.workspaceData))
        .set('isPortal', action.isPortal);
    case actionTypes.MAINUI_HIDE_WORKSPACE_EMAIL_DIALOG:
      return state
        .set('emailWorkspaceData', undefined)
        .set('isPortal', undefined);
    case actionTypes.MAINUI_SHOW_UMO_MODIFY_DIALOG:
      return state
        .set('UMOModifyData', fromJS(action.data))
        .set('umoList', action.umoList)
        .set('modalWorkspaceID', action.modalWorkspaceID);
    case actionTypes.MAINUI_HIDE_UMO_MODIFY_DIALOG:
      return state.set('UMOModifyData', undefined).set('umoList', undefined);
    case actionTypes.MAINUI_SHOW_CATEGORY_MOVE_DIALOG:
      return state
        .set('categoryToMoveID', action.categoryID)
        .set('categoryToMoveName', action.categoryName);
    case actionTypes.MAINUI_SHOW_CATEGORY_FILE_UPLOADER:
      return state
        .set('categoryToUpload', action.categoryToUpload)
        .update('fileUploader', (fileUploader) =>
          fileUploader
            .set('showFileUploader', true)
            .set('isMinimized', false)
            .set('isCollapsed', false)
        );
    case actionTypes.MAINUI_HIDE_CATEGORY_FILE_UPLOADER:
      return state.update('fileUploader', (fileUploader) =>
        fileUploader
          .set('showFileUploader', false)
          .set('isMinimized', false)
          .set('isCollapsed', false)
          .set('isUploading', false)
      );
    case actionTypes.MAINUI_MINIMIZE_CATEGORY_FILE_UPLOADER:
      return state.update('fileUploader', (fileUploader) =>
        fileUploader.set('isMinimized', true).set('isCollapsed', false)
      );
    case actionTypes.MAINUI_MAXIMIZE_CATEGORY_FILE_UPLOADER:
      return state.update('fileUploader', (fileUploader) =>
        fileUploader.set('isMinimized', false).set('isCollapsed', false)
      );
    case actionTypes.MAINUI_COLLAPSE_CATEGORY_FILE_UPLOADER:
      return state.update('fileUploader', (fileUploader) =>
        fileUploader.set('isCollapsed', true)
      );
    case actionTypes.MAINUI_EXPAND_CATEGORY_FILE_UPLOADER:
      return state.update('fileUploader', (fileUploader) =>
        fileUploader.set('isCollapsed', false)
      );
    case actionTypes.MAINUI_FILE_UPLOADER_TOGGLE_UPLOADING:
      return state.update('fileUploader', (fileUploader) =>
        fileUploader.set('isUploading', action.isUploading)
      );
    case actionTypes.MAINUI_UPDATE_COLLECTION_ID_BEING_EDITED:
      return state.set('collectionIdForEdit', action.collectionId);
    case actionTypes.MAINUI_SET_NAV_PANEL_WIDTH: {
      // Save to localStorage for persistence
      localStorage.setItem('navPanelWidth', action.width.toString());
      return state.set('navPanelWidth', action.width);
    }
    case actionTypes.MAINUI_HIDE_CATEGORY_MOVE_DIALOG:
      return state
        .set('categoryToMoveID', null)
        .set('categoryToMoveName', null);
    case sessionActionTypes.UPDATE_STORE_FROM_APPCONFIG:
      return state.set(
        'umoGalleryViewType',
        appConfig.umoGallery && appConfig.umoGallery.gridViewDefault
          ? viewTypes.GRID_NOJ
          : viewTypes.GRID
      );
    case metaActionTypes.META_ATTACH_POPULATE:
      return state.set('metaPanelUmoId', null);
    case metaActionTypes.META_ATTACH_COPY:
      return state.set('metaPanelUmoId', null);
    default:
      return state;
  }
};

export default mainUI;
